import { Fragment } from 'react';

import { useTruncate } from '@nesso/ui/hooks/use-truncate';
import { Tooltip, TooltipContent, TooltipTrigger } from '@nesso/ui/primitives/tooltip';

import { TOOLTIP_TIMEOUT } from '@/shared/constants/tooltip';
import { useLongPressTooltip } from '@/shared/lib/use-long-press-tooltip';

function mapMissingField(field: string) {
    switch (field) {
        case 'dateOfBirth':
            return 'age';
        case 'treatmentApproach':
            return 'treatment approach';
        case 'treatmentFocus':
            return 'treatment focus';
        case 'email_primary':
            return 'primary email';
        default:
            return field;
    }
}

export function ClientTableMissingFieldsCell({ missing }: { missing: string[] }) {
    const { ref: textRef, isTruncated } = useTruncate<HTMLDivElement>({
        dependency: missing.join(','),
    });
    const { open, onOpenChange, longPressHandlers } = useLongPressTooltip({
        enabled: isTruncated,
        delay: 500,
        autoCloseMs: TOOLTIP_TIMEOUT,
    });

    const missingFieldsText = (
        <>
            Missing:{' '}
            {missing.map((field, index) => (
                <Fragment key={field}>
                    {index > 0 && ', '}
                    {mapMissingField(field)}
                </Fragment>
            ))}
        </>
    );

    const content = (
        <div
            ref={textRef}
            className="text-sm text-muted-foreground overflow-hidden text-ellipsis whitespace-nowrap"
            {...longPressHandlers}
        >
            {missingFieldsText}
        </div>
    );

    if (!isTruncated) {
        return content;
    }

    return (
        <Tooltip delayDuration={300} open={open} onOpenChange={onOpenChange}>
            <TooltipTrigger asChild>{content}</TooltipTrigger>
            <TooltipContent side="bottom" align="start" className="max-w-xs">
                <div className="text-sm">{missingFieldsText}</div>
            </TooltipContent>
        </Tooltip>
    );
}
